<p-dialog header="{{ 'LOGIN.WARNING' | translate }}" [(visible)]="displayDelayMessage" [modal]="true"
    [style]="{'width': '350px', 'height': '225px'}" dynamic="true">
    <div>
        <span class="delayTitle">{{'LOGIN.MESSAGES.BEFORE_EXIT_WARNING'|translate}}</span>
        <p-progressBar class="delayProgress" [value]="progressValue" [showValue]="false"></p-progressBar>
        <button class="delayButton" pButton type="button" icon="pi pi-check"
            [label]="'LOGIN.MESSAGES.YES_STAY_WEBSITE' | translate" (click)="okClick()"></button>
    </div>
    <p-footer></p-footer>
    <!-- [icon]="pi-check" -->
</p-dialog>